import cloneDeep from 'lodash/cloneDeep';
import { AnyAction } from 'redux';
import { CheckoutActions } from '../checkout.actions';

export interface Druckstatus {
  beiblattStatus: DruckstatusEnum;
  infopaketStatus: DruckstatusEnum;
  pkbStatus: DruckstatusEnum;
  jagdbestaetigungStatus: DruckstatusEnum;
  weweStatus: DruckstatusEnum;
}

export enum DruckstatusEnum {
  ERROR = 'ERROR',
  ERROR_PREISVALIDIERUNG = 'ERROR_PREISVALIDIERUNG',
  OK = 'OK',
  NICHT_GEDRUCKT = 'NICHT_GEDRUCKT',
}

export const druckstatusReducer = function (
  sectionState: Druckstatus = null,
  action: AnyAction,
): Druckstatus {
  const newState: Druckstatus = cloneDeep(sectionState);
  switch (action.type) {
    case CheckoutActions.BEIBLATT_DRUCKEN_SUCCESS: {
      newState.beiblattStatus = DruckstatusEnum.OK;
      break;
    }
    case CheckoutActions.BEIBLATT_DRUCKEN_ERROR: {
      newState.beiblattStatus = action.payload;
      break;
    }
    case CheckoutActions.INFOPAKET_DRUCKEN_SUCCESS: {
      newState.infopaketStatus = DruckstatusEnum.OK;
      break;
    }
    case CheckoutActions.INFOPAKET_DRUCKEN_ERROR: {
      newState.infopaketStatus = action.payload;
      break;
    }
    case CheckoutActions.PKB_DRUCKEN_SUCCESS: {
      newState.pkbStatus = DruckstatusEnum.OK;
      break;
    }
    case CheckoutActions.PKB_DRUCKEN_ERROR: {
      newState.pkbStatus = action.payload;
      break;
    }
    case CheckoutActions.JAGDBESTAETIGUNG_DRUCKEN_SUCCESS: {
      newState.jagdbestaetigungStatus = DruckstatusEnum.OK;
      break;
    }
    case CheckoutActions.JAGDBESTAETIGUNG_DRUCKEN_ERROR: {
      newState.jagdbestaetigungStatus = action.payload;
      break;
    }
    case CheckoutActions.WEWE_DRUCKEN_SUCCESS: {
      newState.weweStatus = DruckstatusEnum.OK;
      break;
    }
  }
  return newState;
};
